import React from 'react';
import Header from '../components/Header/Header';

import BreadcrumbSchema from "./BreadcrumbSchema";
import ContactUs from '../components/ContactUs/ContactUs';



function Contact() {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #ffffff 50%, #ffffff 100%)",
      }}
      className="min-h-screen"
    >
      <BreadcrumbSchema />
      <Header />
      <div className="mt-16"> {/* 👈 adds space between Header & ContactUs */}
        <ContactUs />
      </div>
    </div>
  )
}

export default Contact
